<template>
  <ModalOverlay
    id="full-review-modal"
    width="74rem"
    :title="title"
  >
    <template #body>
      <div
        class="grid-x"
      >
        <div
          class="cell large-auto small-12 small-margin-top-xs large-margin-top-z"
        >
          <IndividualGenericReview
            v-for="(review, index) in reviews"
            :key="review.reviewId"
            :is-last-review="index === reviews.length - 1"
            :review="review"
            is-profile-view
          />
        </div>
      </div>
      <UserReviewsPagination
        v-show="totalPages > 1"
        v-model="currentPage"
        :options="options"
        :total-pages="totalPages"
      />
    </template>
  </ModalOverlay>
</template>
<script setup>
import { computed } from 'vue';
import { ModalOverlay } from '@atomic-ui/modalOverlay';
import IndividualGenericReview from '@components/reviews/IndividualGenericReview';
import { useReviewerProfilePagination } from '@composables/reviews/useReviewerProfilePagination';
import UserReviewsPagination from '@components/reviews/UserReviewsPagination';

const props = defineProps({
  title: {
    default: 'User Profile',
    type: String,
  },
  isLoading: { type: Boolean, default: false },
  reviews: {
    /** @type import('vue').PropType<Review[]> */
    type: Array,
    required: true,
  },
  totalAuthorReviews: {
    type: Number,
    default: 0,
  },
  authorId: {
    type: String,
    required: true,
  },
  page: {
    type: Number,
    required: true,
  },
});

const emits = defineEmits(['pageChange']);

const currentPage = computed({
  get: () => props.page,
  set: (newPage) => {
    emits('pageChange', {
      id: props.authorId,
      newPage,
    });
  },
});

const {
  totalPages,
  options,
} = useReviewerProfilePagination(props.totalAuthorReviews);

</script>
